import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'app/config/service.config';
import { LogService } from '../logging/log.service';
import { Observable, catchError, map, of } from 'rxjs';
import { TransactionResponse } from './transaction.types';

@Injectable({
    providedIn: 'root'
})
export class TransactionService {
    private _httpClient = inject(HttpClient);
    private _apiServer = inject(AppConfig);
    private _logging = inject(LogService);

    private get baseUrl(): string {
        return this._apiServer.settings.apiServer.eastelService;
    }

    /**
     * Get transactions
     */
    getTransactions(params: any): Observable<TransactionResponse[]> {
        // Clean params
        const cleanParams: any = {};
        Object.keys(params).forEach((key) => {
            if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
                cleanParams[key] = params[key];
            }
        });

        return this._httpClient.get<any>(`${this.baseUrl}/transactions/page`, { params: cleanParams }).pipe(
            map((response) => {
                this._logging.debug('Transaction Service getTransactions', response);
                return response.content || [];
            }),
            catchError((error) => {
                this._logging.error('Error getting transactions', error);
                return of([]);
            })
        );
    }

    /**
     * Get corporate transactions paged
     */
    getCorporateTransactionsPaged(params: any): Observable<any> {
        const cleanParams: any = {};
        Object.keys(params).forEach((key) => {
            if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
                cleanParams[key] = params[key];
            }
        });

        return this._httpClient.get<any>(`${this.baseUrl}/transactions/brn/paged`, { params: cleanParams });
    }

    /**
     * Request async Excel export for transactions
     */
    requestTransactionExport(params: any): Observable<any> {
        const cleanParams: any = {};
        Object.keys(params).forEach((key) => {
            if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
                cleanParams[key] = params[key];
            }
        });

        return this._httpClient.post<any>(`${this.baseUrl}/transactions/statement/xlsx/async`, null, { params: cleanParams });
    }

    /**
     * Poll transaction export job status
     */
    getTransactionExportJobStatus(jobId: string): Observable<any> {
        return this._httpClient.get<any>(`${this.baseUrl}/transactions/statement/xlsx/jobs/${jobId}`);
    }

    /**
     * Download completed transaction Excel export
     */
    downloadTransactionExport(jobId: string): Observable<Blob> {
        return this._httpClient.get(`${this.baseUrl}/transactions/statement/xlsx/jobs/${jobId}/download`, {
            responseType: 'blob'
        });
    }

    /**
     * Download transaction invoice PDF
     */
    downloadTransactionInvoice(transactionNumber: string): Observable<Blob> {
        return this._httpClient.get(`${this.baseUrl}/transactions/${transactionNumber}/pdf/invoice`, {
            responseType: 'blob'
        });
    }
}
